import { render, staticRenderFns } from "./studentPatients.v2.vue?vue&type=template&id=6d2b5d6b&scoped=true"
import script from "./studentPatients.v2.vue?vue&type=script&lang=js"
export * from "./studentPatients.v2.vue?vue&type=script&lang=js"
import style0 from "./studentPatients.v2.vue?vue&type=style&index=0&id=6d2b5d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b5d6b",
  null
  
)

export default component.exports